import * as THREE from 'three';
import { Utils } from '../utils.module';

export class UtilsBuilder {

	public static readonly EARTH = 6378137;

	private _cerrado: boolean; // indica si el perímetro está cerrado.
	private _ang1: any = []; // Angulos que siguen el primer angulo encontrado.
	private _ang2: any = []; // Angulos que invertimos.
	private _coors: any = []; // Coordenadas.
	private _angulosExternos: 0; // Esquinas donde la maya va por el angualo más grande.
	private _angulosInternos: 0; // Esquinas donde la maya va por el angualo más pequeño.

	public constructor() { }

	public get cerrado() { return this._cerrado; }
	public get angulosExternos() { return this._angulosExternos; }
	public get angulosInternos() { return this._angulosInternos; }
	public angulos: any;

	public iniciar(coors: any[]) {
		this._coors = coors;
		// Comprobar si es un recinto cerrado.
		// El array de coordenadas debe ser mayor de 2 y la primera coordenada debe ser igual a la última.
		this._cerrado = (this._coors.length > 2 &&
			this._coors[0].lng === this._coors[this._coors.length - 1].lng &&
			this._coors[0].lat === this._coors[this._coors.length - 1].lat);
		this._ang1 = [];
		this._ang2 = [];
	}

	//#######################################################################################################################
	// Comprueba las direcciones de los angulos para obtener una dirección del perímtro (esto debería ser propio del editor no del código).
	// Usado por todos los cercados y las verjas de los modelos FAX y RITMO.
	public computarAngulos(): number {
		let interms = 0; // Últil para los Cercados FAX.

		// Computar angulos.
		this.angulos = [];
		// ############################################# CERRADO.
		if (this._cerrado) {
			for (let i = 0; i < this._coors.length - 1; i++) {
				let puntoAx = 0;
				let puntoAy = 0;
				if (i == 0) { // Tener en cuenta el principio.
					puntoAx = this._coors[this._coors.length - 2].lng; // Punto Ax
					puntoAy = this._coors[this._coors.length - 2].lat; // Punto Ay
				}
				else {
					puntoAx = this._coors[i - 1].lng; // Punto Ax
					puntoAy = this._coors[i - 1].lat; // Punto Ay
				}
				this.angulos.push(this.angles(
					this._coors[i].lng, // Base
					this._coors[i].lat,
					puntoAx, // Punto Ax
					puntoAy, // Punto Ay
					this._coors[i + 1].lng, // Punto B
					this._coors[i + 1].lat));
			}
		}
		// ############################################# ABIERTO.
		else {
			for (let i = 1; i < this._coors.length - 1; i++) {
				this.angulos.push(this.angles(
					this._coors[i].lng, // Base
					this._coors[i].lat,
					this._coors[i - 1].lng, // Punto Ax
					this._coors[i - 1].lat, // Punto Ay
					this._coors[i + 1].lng, // Punto B
					this._coors[i + 1].lat));
			}
		}

		// Los angulos deben seguir el orden de cierre (1,1)(1,-1)(-1,.1)(-1,1) ciclico sin importar donde empieza.
		let siguiente = 0; // Ciclo lógico, guarda el siguiente angulo lógido. 0 No hay mandato. (1,2,3,4)
		let direccion = 1; // 1 Derecha, -1 izquierda; Por defecto se toma la Derecha, después se reajusta.
		// Obtener la dirección inicial.
		if (this.angulos.length > 1) {
			let aux = this.angulos[0].dir - 1;
			if (aux == 0) aux = 4;
			if (this.angulos[1].dir == aux) direccion = -1; // Cambiar dirección.
		}
		//	var roto = 0; // Se ha roto el ciclo, el siguiente debe ser igual ak último lógico (inicio).
		for (let ang of this.angulos) {
			// Tener en cuenta si se inicio.
			if (siguiente == 0) {
				// Iniciar ciclo.
				siguiente = this._siguienteCiclo(direccion, ang.dir);
				interms += this._insertarAngulo(direccion, ang);
			}
			else {
				// Ciclo de angulos.
				// Comprobar si rompe el ciclo.
				if (ang.dir == siguiente) {
					// Sigue ciclo.
					siguiente = this._siguienteCiclo(direccion, siguiente);
					interms += this._insertarAngulo(direccion, ang);
				}
				else {
					direccion *= -1; // Cambiar dirección.
					siguiente = this._siguienteCiclo(direccion, ang.dir);
					interms += this._insertarAngulo(direccion, ang);
				}
			}
		}

		// Dependiendo de la cantidad de angulos gana el que más tiene (ang1, ang2).
		this._angulosExternos = this._ang1.length;
		this._angulosInternos = this._ang2.length;
		if (this._angulosInternos > this._angulosExternos) {
			this._angulosInternos = this._angulosExternos;
			this._angulosExternos = this._ang2.length;
		}

		return interms;
	}

	// Devuelve el siguiente angulo del ciclo.
	private _siguienteCiclo(direccion: number, ciclo: number) {
		ciclo += direccion;
		if (ciclo > 4) return 1;
		if (ciclo < 1) return 4;
		return ciclo;
	}

	// Inserta en ang1 o ang2, dependiendo de la dirección.
	// Tiene en cuenta si está dentro de los angulos permitidos.
	private _insertarAngulo(direccion: number, angulo: any): number {
		if (angulo.grados < 40 || angulo.grados > 140) return 1; // Aviso para incrementar internos.
		if (direccion == 1) this._ang1.push(angulo); else this._ang2.push(angulo);
		return 0;
	}

	// ##########################################################
	// Obtiene el angulo de dos líneas que se intersectan y su dirección.
	// Direcciones: 1, 2, 3, 4 partiendo siempre del punto centro.
	// 1 -> ( 1, 1) Izquierda-Abajo.
	// 2 -> ( 1,-1) Izquierda-Arriba.
	// 3 -> (-1, 1) Izquierda-Abajo.
	// 4 -> (-1,-1) Izquierda-Abajo.
	// (basex, basey) punto de intersección de las líneas.
	// (x1,y1) y (x2,y2) puntos de las líneas.
	private angles(basex: number, basey: number, x1: number, y1: number, x2: number, y2: number): any {
		basex *= 10; basey *= 10; x1 *= 10; y1 *= 10; x2 *= 10; y2 *= 10;
		// Normalizar vectores.
		x1 -= basex; y1 -= basey; x2 -= basex; y2 -= basey;
		// Obtener la orientación.
		let dir = 0;
		if ((x1 + x2) >= 0) { // (1, ?)
			dir = ((y1 + y2) >= 0) ? 1 : 2; // (1, 1) : (1, -1)
		} else { // (-1, ?)
			dir = ((y1 + y2) >= 0) ? 4 : 3; // (-1, 1) : (-1, -1)
		}
		// Producto de las líneas.
		let up = Math.abs((x1 * x2) + (y1 * y2)); // valor absoluto
		let down = Math.sqrt((x1 * x1) + (y1 * y1)) * Math.sqrt((x2 * x2) + (y2 * y2));
		let r = up / down;
		// Angulo en radianes.
		let radianes = Math.acos(r);
		// Pasar radianes a grados.
		return { dir, grados: radianes * 180 / Math.PI };
	}

	// Devuelve la coordenada xy sobre le línea (x1,y1,x2,y2) partiendo del % (margin) desde la coordenada (x1,y1).
	public getXYByMargin(x1: number, y1: number, x2: number, y2: number, margin: number) {
		let pB = { x: x2 - x1, y: y2 - y1 }; // Situarse en cero. pB.x -= pA.x; pB.y -= pA.y;
		let normalX = 1;
		if (pB.x < 0) { pB.x *= -1; normalX = -1; }
		let normalY = 1;
		if (pB.y < 0) { pB.y *= -1; normalY = -1; }
		// Longitud A-B.
		let hipotenuse = Math.sqrt(Math.pow(pB.x, 2) + Math.pow(pB.y, 2));
		let radio = (hipotenuse * margin) / 100; // %
		// Angulo en radianes.
		let angle = Math.asin(pB.y / hipotenuse);
		// console.log("X1  "+x1);
		// console.log("X2  "+x2);
		// console.log("y1  "+y1);
		// console.log("y2  "+y2);
		// console.log("MARGIIIIINNN")
		// console.log(margin)
		
		return {
			x: ((radio * Math.cos(angle)) * normalX) + x1,
			y: ((radio * Math.sin(angle)) * normalY) + y1
		};

	}

	// FIXME VERSIÓN ANTIGUA: CORRECCIÓN DE PERÍMETROS QUE SE ALEJAN DE BARCELONA. LatLngToXYZ
	// TODO Rectificar para dejar como antes:
	// TODO 	Cambiar el nombre latLngToVector3d_ a latLngToVector3d
	public static latLngToVector3d_(lat: number, lng: number, radius = UtilsBuilder.EARTH) {
		const spherical = new THREE.Spherical(radius,
			Math.PI * (0.5 - (lat / 180)),	// phi
			Math.PI * (lng / 180));			// theta
		return new THREE.Vector3().setFromSpherical(spherical);
	}

	// FIXME VERSIÓN NUEVA: CORRECCIÓN DE PERÍMETROS QUE SE ALEJAN DE BARCELONA. LatLngToXYZ
	// TODO Rectificar para dejar como antes: comentar.
	public static latLngToVector3d(lat: number, lng: number, radius = UtilsBuilder.EARTH) {
		const phi = (90 - lat) * Math.PI / 180;
		const theta = (90 - lng) * Math.PI / 180;
		return new THREE.Vector3(
			radius * Math.sin(phi) * Math.cos(theta),
			radius * Math.cos(phi),
			radius * Math.sin(phi) * Math.sin(theta)
		);
	}

	/*public static latLngToVector3d_new(lat: number, lng: number, radius = UtilsBuilder.EARTH) {
		const phi = (90 - lat) * (Math.PI / 180);
		const theta = (lng + 180) * (Math.PI / 180);
		return new THREE.Vector3(
			-((radius) * Math.sin(phi) * Math.cos(theta)),
			((radius) * Math.sin(phi) * Math.sin(theta)),
			((radius) * Math.cos(phi))
		);
	}*/

	public static vector3dToLatLng(v3: THREE.Vector3) {
		const spherical = new THREE.Spherical().setFromVector3(v3);
		return {
			lat: 180 * (0.5 - (spherical.phi / Math.PI)),
			lng: 180 * (spherical.theta / Math.PI)
		};
	};

	// ##### Retorna el Vector3 entre 'pointA' y 'pointB' partiendo de 'pointA' con el marge 'tramo'.
	public tramoAtoB(pointA: THREE.Vector3, pointB: THREE.Vector3, tramo: number): THREE.Vector3 {
		let v = pointB.clone().sub(pointA).normalize().multiplyScalar(tramo);
		return pointA.clone().add(v);
	}

	public angleAtoB(va: THREE.Vector3, vb: THREE.Vector3) {
		let negativo = false;
		if (va.x > vb.x) negativo = (va.z < vb.z); else negativo = (va.z < vb.z);

		let v = new THREE.Vector3(vb.x - va.x, 0, vb.z - va.z);
		let v0 = new THREE.Vector3(0, 0, 0);
		let hipo = v0.distanceTo(v);
		let coX = v.x;
		let coY = v.y;
		let acos = Math.acos(coX / hipo);
		if (negativo) return -acos;
		return acos;
	}

	public static RadianToAngle(value: number) { return value * 180 / Math.PI; }
	public static AngleToRadian(value: number) { return value * Math.PI / 180; }

}